import { QuestionHelper } from '..';

export const useQuestion = () => {
	let questionHelper = new QuestionHelper();
	return {
		questionHelper,
		activeQuestion: questionHelper.active()
	};
};
